<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/V1SKvk/tc-custom/9781613124857.jpg?1701092266882" alt="This image is the cover for the book Constable & Toop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Constable & Toop
      </h1>
      <p class="bookDescription body article font2">
        <b>“Sure to tickle the funny bone and satisfy the taste for some gruesome adventure while appealing to both girls and boys. A fun read.” —<i>School Library Journal</i></b><br/><br/>Something mysterious and terrible is happening throughout Victorian London: Ghosts are disap­pearing. When this reaches the attention of the Ghost Bureau, the diligent but clueless Mr. Lapsewood, a paranormal paper-pusher, is sent to investigate, and what he discovers is grave. The Black Rot has arrived—a voracious spiritual infestation whereby empty haunted houses suck in unsuspecting ghosts and imprison them. Lapsewood’s investigation weaves through the stories of several other memorable characters—living and dead—including an undertaker’s son who can see ghosts, a serial throat-slasher reminiscent of Jack the Ripper, an evangelical exorcist, and many more. The living and dead must work together if they hope to destroy the Black Rot—before it destroys both the ghost and human worlds. <br/><br/>“Jones has crafted a menacing, spooky Victorian London full of criminals and unfinished business, which is well balanced by the biting satire and buffoonery of the Bureau. Add to that a cast of fascinating, well-wrought characters—from the smarmy and threatening Jack, to the precocious, pot-stirring aspiring journalist Clara—and it’s a winning combination of macabre atmosphere, whimsical antics, and heartfelt, earnest friendship.” —<i>Booklist</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth P. Jones
      </h2>
      
      <p class="authorDescription body article">Gareth P. Jones is the popular UK-based author of The Dragon Detective Agency series, The Considine Curse (Blue Peter Book of the Year 2012), and the Ninja Meerkats series. He is also a TV producer and plays “a slightly ludicrous number of stringed instruments.”</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b0013a4